import { useCallback, useMemo, useState } from 'react'
import { detectLocale, localeDir, LOCALE_STORAGE_KEY } from './deposit'
import { LocaleContext } from './locale-context.js'

// App-wide language preference, shared by the header LanguageSwitcher and the
// guest deposit flow. It only holds state + persists it — it never sets
// document/<html> dir, because the marketing/app shell is English-only and
// flipping <html> would drag that English UI into RTL. Consumers that ARE
// translated (the deposit page) apply `dir` to their own container.
export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() =>
    typeof window !== 'undefined' ? detectLocale(window.location.search) : 'en',
  )

  const setLocale = useCallback((next) => {
    setLocaleState(next)
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, next)
    } catch {
      /* ignore */
    }
  }, [])

  const value = useMemo(
    () => ({ locale, setLocale, dir: localeDir(locale) }),
    [locale, setLocale],
  )

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
}
